import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { PlanDay } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

import { DailyResource } from '../utils/dailyResource';

/**
 * Register the open Daily Practice day with Lubav so its turns cite the real day — the date, the
 * day's targets, and the resource on offer — rather than inventing them. Registers nothing when no
 * day is open.
 */
export const useDailyPracticeAgentContext = (
  day: PlanDay | null,
  resource: DailyResource | null,
) => {
  useRegisterAgentContext(
    day
      ? {
          kind: 'visual',
          label: 'Daily Practice day',
          display:
            'A study-plan day with its skill targets, a resource card, and (on study days) a five-question practice quiz.',
          detail:
            'Ground any discussion in this day’s targets and resource; do not invent quiz questions or other days.',
          data: {
            date: day.date,
            week: day.week,
            kind: day.kind,
            completed: day.completed,
            targets: day.targets.map((target) => ({
              section: target.section,
              ...(target.skillText ? { skillText: target.skillText } : {}),
              ...(target.category !== target.section ? { category: target.category } : {}),
            })),
            resource: resource
              ? {
                  kind: resource.kind,
                  section: resource.section,
                  url: resource.url,
                  ...(resource.timing ? { timing: resource.timing } : {}),
                }
              : null,
          },
        }
      : null,
  );
};
